import * as React from 'react'
import { Typography } from '@mui/material'
export default function HeadingText(props) {

    return (
        <>
            <Typography
                sx={{
                    textAlign: 'center', fontSize: 30, fontWeight: 'bolder', textShadow: 'white 3px 3px 5px',
                    backgroundColor: '#FFCA08', color: '#780202', borderRadius: 3,
                    // borderBottom: '5px double black', ml: 20, mr: 20, mb: 5
                }}>{props.text}</Typography>
        </>
    )
}